export enum SelectedStatus {
    Default = 0,
    Selected = 1
}

export enum Basemaps {
    Mamma = "mammaBasemap",
    Orto = "ortoBasemap"
}

export enum Condition {
    Is = "is",
    Not = "not"
}

export enum ApplicantType {
    Individual = 0,
    Company = 1
}

export enum AttachmentType {
    Path = "Download",
    File = "FileProvider"
}

export enum PrintType {
    Path = 1,
    File = 2
}

export enum Result {
    Success = "Success",
    Error = "Error"
}

export enum UploadState {
    SubmitForm = "SubmitForm",
    CreatePdf = "CreatePdf",
    UploadPdf = "UploadPdf",
    SendEmail = "SendEmail"
}

export enum ImageLoadingState {
    Loading = "Loading",
    NoImages = "NoImages"
}
